import helpers from '@/router/helpers';

// Children
import InventoryJoinPhysical from './routes/JoinPhysical';
import InventoryShelve from './routes/Shelve';
import InventoryPartnerShip from './routes/PartnerShip';

export default {
    path: '/inventory',
    name: 'Inventory',
    meta: {
        title: 'Inventory',
        documentTitle: 'Inventory',
        requiresAuth: true,
        mdiIcon: 'email',
    },
    component: helpers.getRouterView(),
    children: [
        InventoryShelve,
        InventoryJoinPhysical,
        InventoryPartnerShip,
    ],
};
